import { render } from "./ReportCard.vue?vue&type=template&id=5b0dfd41"
import script from "./ReportCard.vue?vue&type=script&lang=js"
export * from "./ReportCard.vue?vue&type=script&lang=js"

import "./ReportCard.vue?vue&type=style&index=0&id=5b0dfd41&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__